import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';
import DefaultScreen from '@components/Global/DefaultScreenView';
import PasswordResetModal from '../../TopLevel/Components/PasswordResetModal';
import ProfileSection from './Components/ProfileSection';
import { YStack } from 'tamagui';

const ProfileScreen = () => {
  const user = useSelector((state: DefaultRootState) => state.promiseData?.data.userData);
  const company = useSelector((state: DefaultRootState) => state.promiseData?.data.companyData);

  return (
    <DefaultScreen backButton scrollDisabled screenTitle={'Settings'} style={{ flex: 1, paddingBottom: 4, top: 0, paddingTop: 0 }} containerStyle={{ maxHeight:'85vh', paddingBottom: 90, flex: 1, top: 0, paddingTop: 0 }}>
      <PasswordResetModal emailForward={user.email} />
      {/* <MFAModal /> */}
      <YStack maxHeight="85vh">
      <ProfileSection user={user} company={company} />
      </YStack>
    </DefaultScreen>
  );
}

export default ProfileScreen;